interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps): JSX.Element {
  return (
    <div
      aria-hidden
      className={`animate-pulse rounded-lg bg-brand-charcoal/[0.08] ${className}`}
    />
  );
}

export function DashboardStatsSkeleton(): JSX.Element {
  return (
    <section
      aria-busy="true"
      aria-label="Loading dashboard"
      className="grid grid-cols-2 gap-3 py-4 sm:grid-cols-3"
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="rounded-xl bg-brand-steel p-4 ring-1 ring-brand-steel"
        >
          <Skeleton className="h-3 w-20" />
          <Skeleton className="mt-3 h-7 w-16" />
        </div>
      ))}
    </section>
  );
}

export function RecentEntriesSkeleton(): JSX.Element {
  return (
    <section
      aria-busy="true"
      aria-label="Loading recent entries"
      className="flex flex-col gap-2 pb-6"
    >
      <Skeleton className="h-4 w-16" />
      <ul className="flex flex-col gap-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <li
            key={i}
            className="rounded-lg bg-brand-steel p-3 ring-1 ring-brand-steel"
          >
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="mt-2 h-3 w-1/3" />
          </li>
        ))}
      </ul>
    </section>
  );
}

export function ApprovalsSkeleton(): JSX.Element {
  return (
    <div
      aria-busy="true"
      aria-label="Loading approvals"
      className="flex flex-col gap-4"
    >
      {Array.from({ length: 2 }).map((_, group) => (
        <div key={group} className="flex flex-col gap-3">
          <Skeleton className="h-3 w-44" />
          <div className="rounded-xl bg-brand-steel p-4 ring-1 ring-brand-steel">
            <div className="flex items-baseline justify-between gap-3">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-7 w-16" />
            </div>
            <div className="mt-3 flex items-baseline justify-between gap-3">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-3 w-20" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function JobsSkeleton(): JSX.Element {
  return (
    <div
      aria-busy="true"
      aria-label="Loading jobs"
      className="flex flex-col gap-3"
    >
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="rounded-xl bg-brand-steel p-4 ring-1 ring-brand-steel"
        >
          <div className="flex items-baseline justify-between gap-3">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-7 w-16" />
          </div>
          <div className="mt-3 flex items-baseline justify-between gap-3">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-32" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SessionLogSkeleton(): JSX.Element {
  return (
    <section
      aria-busy="true"
      aria-label="Loading session"
      className="flex flex-col gap-4 py-4"
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-3 w-56" />
      </div>
      <Skeleton className="h-14 w-full" />
    </section>
  );
}
